import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { LocaleContext } from '../locale/LocaleProvider';
import { isFunction } from '../utils';

const textContainerRules = ({
  theme,
  bold,
  uppercase,
  color,
  fontSize,
  letterSpacing,
  lineHeight,
  align,
  textTransform,
}) => ({
  extend: [
    {
      condition: color,
      style: {
        color: theme.color[color],
      },
    },
    {
      condition: fontSize,
      style: {
        fontSize: theme.fontSize[fontSize],
      },
    },
    {
      condition: bold,
      style: {
        fontWeight: 'bold',
      },
    },
    {
      condition: uppercase,
      style: {
        textTransform: 'uppercase',
      },
    },
    {
      condition: letterSpacing,
      style: {
        letterSpacing,
      },
    },
    {
      condition: lineHeight,
      style: {
        lineHeight,
      },
    },
    {
      condition: align,
      style: {
        textAlign: align,
      },
    },
    {
      condition: textTransform,
      style: {
        textTransform,
      },
    },
  ],
});

const Text = (props) => {
  const {
    bold,
    color,
    fontSize,
    uppercase,
    align,
    letterSpacing,
    lineHeight,
    id,
    values,
    children,
    textTransform,
    ...otherProps
  } = props;
  const context = useContext(LocaleContext);
  const { css } = useFela({
    bold,
    color,
    fontSize,
    uppercase,
    align,
    letterSpacing,
    lineHeight,
    textTransform,
  });

  if (id) {
    const msg = context[id] || id;

    return (
      <span className={css(textContainerRules)} {...otherProps}>
        {isFunction(msg) ? msg(values) : msg}
      </span>
    );
  }

  return (
    <span className={css(textContainerRules)} {...otherProps}>
      {children}
    </span>
  );
};

Text.propTypes = {
  id: PropTypes.string,
  values: PropTypes.object,
  children: PropTypes.node,
  bold: PropTypes.bool,
  color: PropTypes.string,
  fontSize: PropTypes.string,
  uppercase: PropTypes.bool,
  align: PropTypes.string,
  letterSpacing: PropTypes.string,
  textTransform: PropTypes.string,
  lineHeight: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

export default React.memo(Text);
